import { DefaultError, QueryClient, QueryKey, useQuery, UseQueryOptions, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { centralizedHost } from "~/Utils";

export interface DocumentDetailsResponse {
  id: string;
  project_airport_id: any;
  published: string;

  long_description: string;
  long_description_malay: string;
  long_description_mandarin: string;

  terms_conditions: string;
  terms_conditions_malay: string;
  terms_conditions_mandarin: string;

  technical_id: string;
  document_url: string;
  refer_document_text: string;
  redirect_url: string;
  parent_id_promo: string;
  levels:any;

  image: string;
  banner_image: string;
  square_image: string;
  logo: string;
}

// edit api call
const fetchPageContentDetails = async (id: string): Promise<any> => {
  if (!id) {
    return null;
  }
  const response: any = await axios.get(`${centralizedHost}/api/geo-location-promotion-levels/${id}`);

  return response?.data[0];
};

const usePageDocumentDetails = (
  id: string,
  options?: UseQueryOptions<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>,
  queryClient?: QueryClient
): UseQueryResult<DocumentDetailsResponse, DefaultError> => {
  return useQuery<DocumentDetailsResponse, DefaultError, DocumentDetailsResponse, QueryKey>(
    {
      queryKey: ["pageContenDetails", id],
      enabled: false,
      queryFn: () => {
        return fetchPageContentDetails(id);
      },
      refetchOnWindowFocus: false,
      ...options,
    },
    queryClient
  );
};

export { usePageDocumentDetails };
